import setTranslations from 'services/decorator/translator/setTranslations';
import translatorConnector from 'services/connect/translatorConnector';
import { curry, pipe } from 'rambda';

const then = curry((f, p) => p.then(f));

const getTranslationData = (language = '') => {
    pipe(translatorConnector, then(setTranslations))(language);
};

export default getTranslationData;